
import { Component, Vue, Watch } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'
import Price from '@/components/price/index.vue'
import Header from '@/common/header.vue'
import Footer from '@/common/footer.vue'
import BackTop from '@/common/backtop.vue'
import { getProductList, pageVisit, productTypeListPC } from '@/services/http'
import { readCookie } from '@/tools/tools'
import Regular from '@/components/regular/index.vue'


@Component({
  components: {
    Header,
    Price,
    Footer,
    BackTop,
    Regular
  },
})
export default class extends Vue {
  thirdActive: number = 1 // 1综合、2价格

  loading: boolean = false

  // 分类列表
  productTypeList: any[] = []

  // 分类列表子分类
  productTypeChildren: any[] = []

  // 一级分类id
  productTypeId: string = ''

  // 二级分类id
  firstProductId: string = ''

  currentIndex: number = 0

  currentSubIndex: number = -1

  // 热门推荐列表
  recommendList: [] = []

  // 有无数据
  isNodata: boolean = false

  // 当前页数
  currentpage: number = 1

  // 总条数
  totalnumber: number = 20

  pageNo: number = 1

  priceSort: any = 'asc' // asc上升、desc下降

  orderByprice: any = '' // 价格排序

  pageSize: number = 10

  keywords: string = ''

  typeName: string = ''

  beforeCreate() {
    ; (document as any).querySelector('html').setAttribute('style', 'background-color:#f8f8fb;')
  }

  beforeDestroy() {
    ; (document as any).querySelector('html').removeAttribute('style')
  }

  created() {
    this.getProductTypeList()
    this.getProductList()
    this.pageVisit()
    this.setWhiteStauts()

  }

  @Watch('$route')

  @Action('white/setWhiteStauts') setWhiteStauts!: Function

  routechange() {
    this.getProductList()
  }

  handTips() {
    (this as any).$refs.RegularRef.dialogVisible = true
  }

  private goDetails(list: any) {
    if (list.productSku) {
      this.$router.push(`/details?id=${list.id}&productPriceId=${list.natureIds}&from=classify`)
    } else {
      this.$router.push(`/details?id=${list.id}&from=classify`)
    }
  }

  // 综合、价格回调
  setThird(num: number) {
    this.pageNo = 1
    if (this.thirdActive === num && num === 1) return
    const asc: any = document.querySelector('.el-icon-caret-top')
    const desc: any = document.querySelector('.el-icon-caret-bottom')
    if (num === 1) {
      asc.style.color = '#666'
      desc.style.color = '#666'
      this.priceSort = 'asc'
      this.orderByprice = ''
      this.thirdActive = num
      this.getProductList()
    } else if (num === 2) {
      this.priceSort = this.priceSort === 'asc' ? 'desc' : 'asc'
      if (this.priceSort === 'asc') {
        asc.style.color = '#666'
        desc.style.color = '#0043ff'
      } else {
        asc.style.color = '#0043ff'
        desc.style.color = '#666'
      }
      this.thirdActive = num
      this.orderByprice = this.priceSort === 'asc' ? 'desc' : 'asc'
      this.getProductList()
    }
  }

  // 选择分类
  async selectMenu(productTypeId: string, index: number) {
    this.currentIndex = index
    this.currentSubIndex = -1
    this.productTypeId = productTypeId
    if (index !== 0) {
      this.getProductList()
    }
  }

  // 选择二级分类
  async selectSubMenu(productTypeId: string, index: number) {
    this.currentSubIndex = index
    this.firstProductId = productTypeId
    this.getProductList()
  }

  private async getProductTypeList() {

    const res: any = await productTypeListPC({
      companyId: 1,
    })
    res.data.data.unshift({
      typeName: '全部',
    })
    this.productTypeList = res.data.data
  }

  // 获取商品分页列表
  async getProductList() {
    const anchor = readCookie('anchor')
    this.keywords = this.$route.query.keyword ? String(this.$route.query.keyword) : ''
    const res: any = await getProductList({
      priceOrderBy: this.orderByprice,
      keyword: this.$route.query.keyword,
      // eslint-disable-next-line no-nested-ternary
      productTypeId: this.firstProductId
        ? this.firstProductId
        : this.$route.query.productTypeId
          ? this.$route.query.productTypeId
          : '',
      // eslint-disable-next-line no-nested-ternary
      parentTypeId: this.productTypeId
        ? this.productTypeId
        : this.$route.query.parentTypeId
          ? this.$route.query.parentTypeId
          : '',
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      model: anchor ? anchor.model : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      clickFlag: 1,
      companyId: 1,
    })
    if (res.data.code === 100) {
      this.recommendList = res.data.data.list
        // this.typeName = res.data.data.list.length !== 0 ? res.data.data.list[0].typeStr : '';
        ; (this as any).typeName = this.$route.query.name
      this.totalnumber = res.data.data.total
      this.isNodata = this.recommendList.length === 0
    } else {
      this.$message.error(res.data.message)
    }
  }

  handleCurrentChange(val: number) {
    this.pageNo = val
    this.getProductList()
  }

  handleSizeChange(val: number) {
    this.pageSize = val
    this.getProductList()
  }

  // 访问页面数据埋点
  private pageVisit() {
    const anchor = readCookie('anchor')
    pageVisit({
      pageType: 2,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      companyId: 1,
    })
  }
}
